import api from "@/lib/api";

function toSafeCount(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function getByStatusCount(byStatus, status) {
  return toSafeCount(byStatus?.[status]);
}

export function getBySeverityCount(byStatusSeverity, severity) {
  return toSafeCount(byStatusSeverity?.[severity]);
}

// Some backends expose a status+severity matrix. Support common variants
// while defaulting to zero for missing keys.
export function getByStatusSeverityCount(byStatusSeverity, status, severity) {
  if (!byStatusSeverity || typeof byStatusSeverity !== "object") return 0;

  const nested = byStatusSeverity?.[status];
  if (nested && typeof nested === "object") {
    return toSafeCount(nested?.[severity]);
  }

  return toSafeCount(
    byStatusSeverity?.[`${status}:${severity}`]
    ?? byStatusSeverity?.[`${status}_${severity}`]
    ?? byStatusSeverity?.[`${status}|${severity}`],
  );
}

export async function fetchIncidentStatusCounts() {
  const response = await api.get("/analytics/incidents/status-counts");
  const payload = response?.data?.data || response?.data || {};

  return {
    by_status: payload?.by_status && typeof payload.by_status === "object" ? payload.by_status : {},
    by_status_severity:
      payload?.by_status_severity && typeof payload.by_status_severity === "object"
        ? payload.by_status_severity
        : {},
    total: toSafeCount(payload?.total),
    raw: payload,
  };
}
